import { WinningCard } from "../../lib/localStorage"
import { BaseModal } from "./BaseModal"

type Props = {
    isOpen: boolean,
    handleClose: () => void,
    cards: WinningCard[] | null
}

export const CardsModal = ({ isOpen, handleClose, cards }: Props) => {
    return (
        <BaseModal
            title={''}
            isOpen={isOpen}
            handleClose={handleClose}
        >
            <div className="grid grid-cols-4 mt-4 place-items-center">
                {cards?.map((card) => {
                    return <div className="mr-4">
                        <img className="object-cover h-40 w-40 mb-3 rounded-md" src={card.image} />
                    </div>
                })}
            </div>
        </BaseModal>
    )
}